import { API_URL } from "../../utils/contextHelpers";
import { api, buildQuery } from "./core";

export const getnetEstado = api(
  "getnetEstado",
  ({ key, pedido }) =>
    `${API_URL}pagos/getnet/estado?${buildQuery({ key, pedido })}`
);

export const getnetEstadoRequest = async (params) => await getnetEstado(params);
